<template>
    <div>
        <template v-if="size > 0">
            <div class="file-type dark">
                <span>{{ format_size }}</span>
            </div>
        </template>
    </div>
</template>

<script>

    import Vue from 'vue';
    import {common} from "@mixins/common";
    import {storeMapper} from '@mixins/storeMapper';

    export default {
        name: "HkepDisplaySize",
        mixins:[common,storeMapper],
        props: {
            size: {
                default: 0,
                type: Number
            }
        },
        computed: {
            format_size: function() {
                return this.formatSize(this.size);
            }
        }
    }
</script>

<style scoped>
    .obj-resources-table .file-type span {
        font-size: 0.75rem;
        color: #a3a3a3;
        white-space: nowrap;
        text-align: left;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/HkepDisplaySize.vue